import React from 'react';
import { useQuery } from 'jsonapi-react';
import { WeeklyChallengeProvider } from '@/providers/WeeklyChallenge';
import WeekChallengeAdmin from '@/pages/Admin/WeekChallenge';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { useNavigate, useLocation } from 'react-router-dom';
import WeekChallengeDefault from './Default';
import WeekChallengePlayful from './Playful';

export function WeekChallenge(props) {
  return (
    <WeeklyChallengeProvider>
      <WeekChallengeContent {...props} />
    </WeeklyChallengeProvider>
  );
}

function WeekChallengeContent(props) {
  const { selectedTab } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const uri = location.pathname;
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });
  const isPlayfulStudentTheme = usePlayfulStudent();

  if (isAdmin)
    return (
      <WeekChallengeAdmin
        selectedTab={selectedTab}
        uri={uri}
      />
    );

  const { data: challenges, isLoading } = useQuery('/challenges');

  const sharedProps = { challenges, isLoading, selectedTab, uri, navigate };

  return isPlayfulStudentTheme ? <WeekChallengePlayful {...sharedProps} /> : <WeekChallengeDefault {...sharedProps} />;
}
